import {GuideFilter} from "../filters/GuideFilter";

export interface Log {
    id: string;
    user: LogUserInfo;
    request: RequestLog;
    responseCode: string;
}

export interface LogUserInfo {
    id: string | null;
    fullName: string | null;
    ip: string;
}

export interface RequestLog {
    uri: string;
    method: string;
    body: string;
    time: string;
}

export interface LogsGuideFilter extends GuideFilter {
    userSearch: string | null;
    uriSearch: string | null;
    bodySearch: string | null;
    ipSearch: string | null;
    responseCodeSearch: string | null;
    method: HttpMethod[];
    timeFrom: string | null;
    timeTo: string | null;
    sortedField: LogsSortedField | null;
}

export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
    OPTIONS = 'OPTIONS',
    HEAD = 'HEAD',
}

export enum LogsSortedField {
    USER = 'USER',
    URI = 'URI',
    METHOD = 'METHOD',
    CODE = 'CODE',
    TIME = 'TIME'
}